module.exports = __webpack_public_path__ + "static/media/train-icon.f34467a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/train-icon.svg
// module id = 334
// module chunks = 0